var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-tooltip',_vm._g(_vm._b({attrs:{"bottom":_vm.bottom},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({on:{"click":function($event){return _vm.$emit('click')}}},on),[_vm._t("default")],2)]}}],null,true)},'base-tooltip',_vm.$attrs,false),_vm.$listeners),[_c('span',[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }